/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const onClientEntry = () => {
  if (typeof navigator !== 'undefined' && /JavaFX/i.test(navigator.userAgent)) {
    document.documentElement.classList.add('javafx-webview');
  }
};

// Report every client-side route change to analytics.js. Gatsby navigates via
// its own router (@reach/router), which the script's History-API fallback does
// not reliably catch (e.g. blog post pages) — this is the authoritative signal.
// window.rbAnalytics.navigate dedupes, so it never double-counts a navigation.
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && window.rbAnalytics && location) {
    window.rbAnalytics.navigate(location.pathname);
  }
};
